import React from 'react';

export type FormValueEmptyProps = {
    className   : string
    field       : any
    disabled    : boolean

    onClick     : callback

    children?   : any
}

export default function FieldPopover_FormValueEmpty(props: FormValueEmptyProps) {

    const classes = Classes("ui5-txt-no-accent-default", "ui5-field-form-editable", "dropdown-form", "h-36", props.className, {
        "is-disabled": props.disabled
    })

    return (
        <React.Fragment>
            <div className  = {classes}
                 onClick    = {props.onClick}>

                {_.get(props.field.components, 'ValueIcon', false)}

                {props.field.placeholder}

            </div>

            {props.children}

        </React.Fragment>
    )
}
